<div class="modal-header">
  <h4 class="modal-title">{{ dialogHeader }}</h4>
</div>
<div class="modal-body" (keyup.esc)="cancel()" (keyup.enter)="enterPressed()">
  @if (dialogPrompt) {
    <div class="mb-2">{{ dialogPrompt }}</div>
  }
  @if (mode === 'text') {
    <div>
      <dx-text-box #inputComponent [(value)]="dialogValue" valueChangeEvent="input"></dx-text-box>
    </div>
  }
  @if (mode === 'password') {
    <div>
      <dx-text-box #inputComponent [(value)]="dialogValue" [mode]="'password'" valueChangeEvent="input" (onInput)="onInput($event)"></dx-text-box>
    </div>
  }
  @if (mode === 'textarea') {
    <div>
      <dx-text-area #inputComponent [(value)]="dialogValue" [height]="300"></dx-text-area>
    </div>
  }
  @if (mode === 'select') {
    <div>
      <dx-select-box #inputComponent [(value)]="dialogValue" [items]="dialogValueArray"></dx-select-box>
    </div>
  }
  @if (mode === 'selectWithId') {
    <div>
      <dx-select-box #inputComponent [(value)]="dialogValue" [items]="dialogValueArray" [valueExpr]="valueExpr" [displayExpr]="displayExpr" ></dx-select-box>
    </div>
  }
  @if (mode === 'date') {
    <div>
      <dx-date-box #inputComponent [(value)]="dialogValue" ></dx-date-box>
    </div>
  }
  @if (!!dialogMessage) {
    <div class="mt-3">
      {{ dialogMessage }}
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-success" (click)="save(true)" [hidden]="!saveAndNewVisible">Save & New</button>
  <button type="button" class="btn btn-success" (click)="save()" [disabled]="processing" >Save</button>
  <button type="button" class="btn btn-light" (click)="cancel()">Cancel</button>
</div>
